const CHANGE_LOADING = 'CHANGE_LOADING';

const updateLoading = (state = { isLoading: false }, action) => {
    const { type = null, viewtype } = action;

    if (type === CHANGE_LOADING) {
        return viewtype;
    }

    return state;
};

export default updateLoading;
